import {
  Box,
  TextField,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useState } from "react";
import { useTranslate } from "react-admin";

import { converttoWgPhoneFormat } from "../../../../utils/index";
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    display: "flex",
    flexDirection: "column",
  },
  containerWithFlex: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    marginTop: 20,
  },
  textWithFlexAndMargin: {
    margin: "20px 10px 0px 0px",
    display: "grid",
    gridTemplateColumns: "150px auto",
  },
  container: {
    margin: "0 20px 20px 0",
    boxShadow: " 0px 2px 5px rgba(0, 0, 0, 0.15)",
    borderRadius: 12,
    backgroundColor: theme.lightGray,
  },
  textButtonStyle: {
    fontWeight: 600,
    fontSize: 20,
    color: theme.pureWhite,
  },
  buttonCancle: {
    height: 50,
    borderRadius: 0,
    borderBottomLeftRadius: 12,
    width: "100%",
    backgroundColor: theme.darkGray2,
    "&:hover": {
      backgroundColor: theme.darkGray2,
    },
  },
  buttonSave: {
    height: 50,
    borderRadius: 0,
    borderBottomRightRadius: 12,
    width: "100%",
    backgroundColor: theme.blue,
    "&:hover": {
      backgroundColor: theme.blue,
    },
  },
  autocomplete: {
    borderRadius: 8,
  },
  textfield: {
    margin: "0px auto",
    width: 150,
    borderRadius: 8,
    [`& fieldset`]: {
      borderRadius: 8,
    },
  },
}));

function EditContactInformation({
  userProfileData,
  onSave,
  postcodes,
  subDistricts,
  districts,
  provinces,
  onCancel,
}) {
  const classes = useStyles();
  const translate = useTranslate();
  const [data, setData] = useState({
    email: userProfileData.email,
    phone: userProfileData.phoneNumber,
    address: userProfileData.address,
    subDistrictId: userProfileData.subDistrictId,
    districtId: userProfileData.districtId,
    provinceId: userProfileData.provinceId,
    postcodeId: userProfileData.postcodeId,
  });

  return (
    <Box className={classes.container}>
      <Box margin="20px" className={classes.mainContainer}>
        <Box className={classes.containerWithFlex}>
          <Typography className={classes.textWithFlexAndMargin}>
            {translate("ra.text.ci.generalInformation.phoneNumber")}
          </Typography>

          <TextField
            required
            variant="outlined"
            label="Required"
            value={data.phone}
            onChange={(e) => setData({ ...data, phone: e.target.value })}
          />
        </Box>
        <Box className={classes.containerWithFlex}>
          <Typography className={classes.textWithFlexAndMargin}>
            {translate("ra.text.ci.generalInformation.email")}
          </Typography>
          <Box flex="4">
            <TextField
              variant="outlined"
              defaultValue={data.email}
              onChange={(e) => setData({ ...data, email: e.target.value })}
            />
          </Box>
        </Box>
        <Box margin="10px 0px 10px 0">
          <Typography>
            {translate("ra.text.ci.generalInformation.address")}
          </Typography>
          <TextField
            variant="outlined"
            placeholder="Address"
            style={{ width: "100%" }}
            defaultValue={data.address}
            onChange={(e) => setData({ ...data, address: e.target.value })}
          />
        </Box>

        <Box display="flex" margin="10px 0px 10px 0">
          <AddressAutoComplete
            options={subDistricts}
            valueProperty="name"
            onChange={(_, input) => {
              setData({ ...data, subDistrictId: input.id });
            }}
            defaultValue={subDistricts.find(
              (subDis) => subDis.id === data.subDistrictId
            )}
            label={"Sub District"}
          />

          <AddressAutoComplete
            options={districts}
            valueProperty="name"
            onChange={(_, input) => {
              setData({ ...data, districtId: input.id });
            }}
            defaultValue={districts.find((dis) => dis.id === data.districtId)}
            label={"District"}
          />

          <AddressAutoComplete
            options={provinces}
            valueProperty="name"
            onChange={(_, newInputValue) => {
              setData({ ...data, provinceId: newInputValue.id });
            }}
            defaultValue={provinces.find((pro) => pro.id === data.provinceId)}
            label={"Province"}
          />

          <AddressAutoComplete
            options={postcodes}
            valueProperty="code"
            onChange={(_, input) => {
              setData({ ...data, postcodeId: input.id });
            }}
            defaultValue={postcodes.find((post) => post.id === data.postcodeId)}
            label={"Postcode"}
          />
        </Box>
      </Box>

      <Box display="flex" justifyContent="center">
        <Button className={classes.buttonCancle} onClick={onCancel}>
          <Typography className={classes.textButtonStyle}>
            {translate("ra.action.cancel")}
          </Typography>
        </Button>
        <Button
          className={classes.buttonSave}
          onClick={() =>
            onSave({
              email: data.email,
              phone: converttoWgPhoneFormat(data.phone),
              address: data.address,
              subdistrict_id: data.subDistrictId,
              district_id: data.districtId,
              province_id: data.provinceId,
              postcode_id: data.postcodeId,
            })
          }
        >
          <Typography className={classes.textButtonStyle}>
            {translate("ra.action.save")}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
}

const AddressAutoComplete = ({
  label,
  options,
  valueProperty,
  onChange,
  defaultValue,
}) => {
  const classes = useStyles();
  return (
    <Autocomplete
      classes={{ root: classes.autocomplete }}
      options={options}
      getOptionLabel={(option) => {
        return option[valueProperty];
      }}
      onChange={onChange}
      defaultValue={defaultValue}
      renderInput={(params) => (
        <TextField
          variant="outlined"
          // underlineShow={false}
          classes={{ root: classes.textfield }}
          placeholder={label}
          {...params}
        />
      )}
    />
  );
};

export default EditContactInformation;
